import { defineStore } from 'pinia';
import { useIdentityStore } from './IdentityStore';
import ApiService from '@/services/ApiService';
import dayjs from 'dayjs'; 
import JsZip from 'jszip';
import Axios from 'axios';
import { useRMTStore } from './RMTStore';
import { useModalStore } from './ModalStore';

export const useResourceStore = defineStore('resource', {
  state () {
    return {
      filteredResources: [],
      filterUploadResources: [],
      loading: false,
      downloading: false,
      uploadLoading: false,
      uploadCount: 0,
      percent: 0,
      mainSiteUri: 'https://nelsonirrigation.com/',
      singleDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()), // todays date
      // mainSiteUri: 'https://dev.nelsonirrigation.com/'
    };
  },
  getters: {
    resources () { return this.filteredResources; },
    uploads () { return this.filterUploadResources; },
    selectedResources () { return this.filteredResources.filter(function (item) { return item.isSelected; }); },
    uploadResources () { return this.filterUploadResources.filter(function (item) { return item.isSelected; }); },
    favoriteResources () { return this.filteredResources.filter(function (item) { return item.isFavorite; }); },
    selectedFavoriteResources () { return this.favoriteResources.filter(function (item) { return item.isSelected; }); },
    isLoading () { return this.loading; },
    isDownloading () { return this.downloading; },
    downloadPercent () { return this.percent; },
  },
  actions: {
    setProgress (progress) {
      this.downloadPercent = progress;
    },
    clearSelected () {
      this.selectedResources.forEach((resource) => { resource.isSelected = false; });
    },
    clearSelectedUploads () {
      this.filterUploadResources.forEach((upload) => { upload.isSelected = false; });
    },
    selectAll () {
      this.filteredResources.forEach((resource) => { resource.isSelected = true; });
    },
    selectAllUploads () {
      this.filterUploadResources.forEach((upload) => { upload.isSelected = true; });
    },
    selectAllFavorites () {
      this.favoriteResources.forEach((resource) => { resource.isSelected = true; });
    },
    saveFavorites () {
      let idString = '';
      this.favoriteResources.forEach((resource, index) => {
        if (index != 0) {
          idString += ',';
        }
        idString += resource.id;
      });
      const identityStore = useIdentityStore();
      identityStore.setUserProperty({ Favorites: idString });
      identityStore.User.properties.marketing_Favorites = idString;
    },
    async getResources (page, limit, params, searchText, orderBy, orderDescending) {
      this.loading = true;
      await ApiService.getResources(page, limit, params, searchText, orderBy, orderDescending)
        .then(response => {
          const tempResources = response.data;
          tempResources.forEach(this.formatData);
          if (page != 1) {
            this.filteredResources.push(...tempResources);
          } else {
            const selectedIds = this.selectedResources.map((resource) => { return resource.id; });
            const unselectedResources = tempResources.filter(function (item) { return !selectedIds.includes(item.id); });
            this.filteredResources = this.selectedResources.concat(unselectedResources);

          }
          this.loading = false;
        })
        .catch(error => {
          throw (error);
        });
    },
    async resourcesForCollection (collection, page, limit) {
      this.loading = true;
      ApiService.fetchResourcesForCollection(collection.cID, page, limit).then(response => {
        var resources = response.data;
        resources.forEach(this.formatData);
        if (page != 1) {
          collection.resources.push(...resources);
        } else {
          collection.resources = resources;
        }
        this.loading = false;
        return resources;
      });

    },
    async downloadResourcesZip (items) {
      var self = this;
      if (items.length === 0) { return; }
      const zipper = new JsZip();
      let progress = 0;
      var promises = items.map(function (value) {
        self.downloading = true;
        const config = {
          headers: {
            accept: '*/*',
          },
          responseType: 'blob',
        };
        return Axios.get(value.downloadUri, config);
      });
      var finalPromise = Promise.all(promises);
      promises.forEach(p => p.then((response) => {
        if (progress === promises.length - 1) {
          setTimeout(() => {
            self.downloading = false;
            self.percent = 0;
          }, 400);
        }
        console.log(response);
        progress++;
        zipper.file(response.request.responseURL.split('/').pop(), response.data,{base64: false});
        self.percent = progress / promises.length * 100;
      }));
      finalPromise.then((result) => {
        console.log(result);
        const link = document.createElement('a');
        zipper.generateAsync({ type: 'blob' }).then(function (blob) {
          var url = window.URL.createObjectURL(blob);
          // link.href = 'data:application/zip;blob,' + base64;
          link.href = url;
          link.download = 'resources';
          link.click();
          URL.revokeObjectURL(link.href);
        });
      });
    },
    async postUploadedResource (resource, num, uploads) {
      await ApiService.editResource(resource)
      .then((result) => {
        this.postUploadFiles(result, resource, num, uploads);
      });
    },
    async postUploadFiles (result, item, num, uploads) {
          let resourcePk = result.data.key; 
          let blob = item.fileBlob;
          // file extension
          let resourceUri =  result.data.resourceUri;
          let fileExt = resourceUri.split('.').pop();

          await ApiService.uploadResource(resourcePk, '.' + fileExt, blob)
          .then(() => {
            this.uploadCount = this.uploadCount + 1;
            this.percent = (this.uploadCount / uploads.length) * 100;
            if (uploads.length === this.uploadCount) {
              const RMTStore = useRMTStore();
              RMTStore.clearAll();
              RMTStore.uploadCancel();
              RMTStore.inMultiSelectionMode = false;
              const modalStore = useModalStore();
              modalStore.showSnack('Resource Saved.');
              RMTStore.filterResources();
              this.uploadLoading = false; 
              this.uploadCount = 0;
              this.percent = 0;
            }
          });
    },
    bulkUpload (items) { 
      var self = this; 
      if (items.length === 0) { return; } 
      items.map((item, num) => {
        const RMTStore = useRMTStore();
        item.libTypeId = RMTStore.libraryItemData.type.libraryTypeId;
        item.libCategoryId = RMTStore.libraryItemData.category.libraryCategoryId;
        item.date = dayjs(self.singleDate).format('YYYY-MM-DDTHH:mm:ss'); 
        self.uploadLoading = true; 
        var typeResource = {}; 
        typeResource = { 
          key: null, 
          id: 0, 
          isActive: true, 
          nicpn: null, 
          group: null, 
          name: item.name, 
          alt: item.alt, 
          description: item.description, 
          resourceUri: item.name,
          subscription: [], 
          collections: item.collections, 
          dateAddedUtc: item.date, 
          libTypeId: item.libTypeId, 
          libraryCategoryId: item.libCategoryId, 
          tagIds: item.tagIds,
          fileBlob: item.fileBlob
        }; 
        self.postUploadedResource(typeResource, num, items);
      });  
    }, 
    formatData (item) {
      const identityStore = new useIdentityStore();
      item.isSelected = false;
      if (identityStore.User) {
        if (identityStore.User.properties.marketing_Favorites) {
          var favorites = identityStore.User.properties.marketing_Favorites.split(',');
          var isFavorite = favorites.find(function (x) { return x === item.id.toString(); });
          if (isFavorite) {
            item.isFavorite = true;
          } else {
            item.isFavorite = false;
          }
        }
      }
      switch (item.libTypeId) {
        case 0:
          if (item.resourceUri.indexOf('.psd') > -1) {
            item.imageUri = this.mainSiteUri + 'portalresources/images/thumbnails/psd.png';
          } else {
            item.imageUri = this.mainSiteUri + 'portalresources/images/thumbnails/' + item.resourceUri;
          }
          item.downloadUri = this.mainSiteUri + 'portalresources/images/' + item.resourceUri;
          break;
        case 1:
          item.imageUri = this.mainSiteUri + 'portalresources/images/thumbnails/library/' + item.resourceUri.toLowerCase().replace('.pdf','_d200.jpg');
          item.downloadUri = this.mainSiteUri + 'portalresources/library/' + item.resourceUri;
          break;
        case 2:
          item.imageUri = this.mainSiteUri + 'portalresources/images/thumbnails/dwg.png';
          item.downloadUri = this.mainSiteUri + 'portalresources/library/' + item.resourceUri;
          break;
        case 3:
          if (item.resourceUri) {
            var vidID = this.youtube_parser(item.resourceUri);
            item.imageUri = 'https://img.youtube.com/vi/' + vidID + '/2.jpg';
            item.videoUri = 'https://www.youtube.com/embed/' + vidID;
          }
          break;
        default:
      }
      return item;
    },
    youtube_parser (url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return (match && match[7].length == 11) ? match[7] : false;
    },
    async assignTags (tagId, resources, page, limit, params, searchText, orderBy, orderDescending) {
      return ApiService.addResourceTags(tagId, resources)
        .then(() => {
          this.getResources(page, limit, params, searchText, orderBy, orderDescending);
        })
        .catch((error) => {
          console.log('Error: ' + JSON.stringify(error));
          throw error;
        });
    },
    async deleteResourceTags (tagId, resources, page, limit, params, searchText, orderBy, orderDescending) {
      return ApiService.removeResourceTags(tagId, resources)
        .then(() => {
          this.getResources(page, limit, params, searchText, orderBy, orderDescending);
        })
        .catch((error) => {
          console.log('Error: ' + JSON.stringify(error));
          throw error;
        });
    },
  }
});